export default __webpack_public_path__ + "static/media/QueryQueue.9e44b43d.svg";